"use client"
import type React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import useDetectMobileOS from "../../hooks/useDetectMobileOS"
import { useRouter } from "next/navigation"
import Image from "next/image"

interface Feature {
  img: string
  blurDataURL?: string
  redirectIOS?: string
  redirectAndroid?: string
  redirectUrl?: string
}

interface OfferSliderCarouselProps {
  banners: {
    _id: string
    value: string
    link?: string
    setting?: string
    type?: string
    createdAt?: string
    updatedAt?: string
  }[]
}

const OfferSliderCarousel: React.FC<OfferSliderCarouselProps> = ({ banners }) => {
  const router = useRouter()
  const os = useDetectMobileOS()

  const features: Feature[] = banners.map((banner) => ({
    img: banner.value,
    blurDataURL:
      "data:image/webp;base64,UklGRjIAAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSDIAAAABJLUvAQC4A1tXJAAAQU1EVgAA3YAAAADUAAABf///tA==",
    redirectIOS: "https://apps.apple.com/in/app/bright-digi-gold-buy-24k-gold/id1640972173",
    redirectAndroid: "https://play.google.com/store/apps/details?id=com.brightdigigold.customer",
    redirectUrl: banner.link || "",
  }))

  const handleBannerClick = (feature: Feature) => {
    const url = os === "iOS" || os === "Mac" ? feature.redirectIOS : feature.redirectAndroid
    if (feature.redirectUrl === "DAILY_SIP" && url) {
      window.open(url, "_blank")
    } else if (feature.redirectUrl === "PRODUCTS_SCREEN") {
      router.push("/coins")
    } else if (feature.redirectUrl === "BUY_SCREEN?2000") {
      return // Do nothing
    }
  }

  return (
    <div className="offer-slider-container">
      <Swiper
        loop={features.length > 1}
        speed={1000}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        modules={[Autoplay]}
        className=""
      >
        {features.map((feature, index) => (
          <SwiperSlide key={`${index}-Slider`} className="offer-slide" onClick={() => handleBannerClick(feature)}>
            <Image
              src={feature.img}
              alt="Bright DiGi Gold promotional offer"
              layout="responsive"
              width={1500}
              height={0}
              style={{
                width: "100%",
                height: "auto"
              }}
              className="object-contain"
              sizes="100vw" 
              priority={index === 0}
              loading={index === 0 ? "eager" : "lazy"}
              placeholder="blur"
              blurDataURL={feature.blurDataURL}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default OfferSliderCarousel

